export default [
  { name: 'United States of America', symbol: 'US' },
  { name: 'Canada', symbol: 'CA' },
  { name: 'France', symbol: 'FR' },
  { name: 'Germany', symbol: 'DE' },
  { name: 'United Kingdom', symbol: 'GB' },
  { name: 'Afghanistan', symbol: 'AF' },
  { name: 'Albania', symbol: 'AL' },
  { name: 'Algeria', symbol: 'DZ' },
  { name: 'American Samoa', symbol: 'AS' },
  { name: 'Andorra', symbol: 'AD' },
  { name: 'Angola', symbol: 'AO' },
  { name: 'Anguilla', symbol: 'AI' },
  { name: 'Antarctica', symbol: 'AQ' },
  { name: 'Antigua and Barbuda', symbol: 'AG' },
  { name: 'Argentina', symbol: 'AR' },
  { name: 'Armenia', symbol: 'AM' },
  { name: 'Aruba', symbol: 'AW' },
  { name: 'Australia', symbol: 'AU' },
  { name: 'Austria', symbol: 'AT' },
  { name: 'Azerbaijan', symbol: 'AZ' },
  { name: 'Bahamas', symbol: 'BS' },
  { name: 'Bahrain', symbol: 'BH' },
  { name: 'Bangladesh', symbol: 'BD' },
  { name: 'Barbados', symbol: 'BB' },
  { name: 'Belarus', symbol: 'BY' },
  { name: 'Belgium', symbol: 'BE' },
  { name: 'Belize', symbol: 'BZ' },
  { name: 'Benin', symbol: 'BJ' },
  { name: 'Bermuda', symbol: 'BM' },
  { name: 'Bhutan', symbol: 'BT' },
  { name: 'Bolivia', symbol: 'BO' },
  { name: 'Bosnia and Herzegovina', symbol: 'BA' },
  { name: 'Botswana', symbol: 'BW' },
  { name: 'Bouvet Island', symbol: 'BV' },
  { name: 'Brazil', symbol: 'BR' },
  { name: 'British Indian Ocean Territory', symbol: 'IO' },
  { name: 'British Virgin Islands', symbol: 'VG' },
  { name: 'Brunei', symbol: 'BN' },
  { name: 'Bulgaria', symbol: 'BG' },
  { name: 'Burkina Faso', symbol: 'BF' },
  { name: 'Burundi', symbol: 'BI' },
  { name: 'Cabo Verde', symbol: 'CV' },
  { name: 'Cambodia', symbol: 'KH' },
  { name: 'Cameroon', symbol: 'CM' },
  { name: 'Cayman Islands', symbol: 'KY' },
  { name: 'Central African Republic', symbol: 'CF' },
  { name: 'Chad', symbol: 'TD' },
  { name: 'Chile', symbol: 'CL' },
  { name: 'China', symbol: 'CN' },
  { name: 'Christmas Island', symbol: 'CX' },
  { name: 'Cocos (Keeling) Islands', symbol: 'CC' },
  { name: 'Colombia', symbol: 'CO' },
  { name: 'Comoros', symbol: 'KM' },
  { name: 'Congo', symbol: 'CG' },
  { name: 'Dem. Republic of Congo', symbol: 'CD' },
  { name: 'Cook Islands', symbol: 'CK' },
  { name: 'Costa Rica', symbol: 'CR' },
  { name: 'Croatia', symbol: 'HR' },
  { name: 'Cuba', symbol: 'CU' },
  { name: 'Curaçao', symbol: 'CW' },
  { name: 'Cyprus', symbol: 'CY' },
  { name: 'Czechia', symbol: 'CZ' },
  { name: 'Denmark', symbol: 'DK' },
  { name: 'Djibouti', symbol: 'DJ' },
  { name: 'Dominica', symbol: 'DM' },
  { name: 'Dominican Republic', symbol: 'DO' },
  { name: 'East Timor', symbol: 'TL' },
  { name: 'Ecuador', symbol: 'EC' },
  { name: 'Egypt', symbol: 'EG' },
  { name: 'El Salvador', symbol: 'SV' },
  { name: 'Equatorial Guinea', symbol: 'GQ' },
  { name: 'Eritrea', symbol: 'ER' },
  { name: 'Estonia', symbol: 'EE' },
  { name: 'Eswatini', symbol: 'SZ' },
  { name: 'Ethiopia', symbol: 'ET' },
  { name: 'Falkland Islands', symbol: 'FK' },
  { name: 'Faroe Islands', symbol: 'FO' },
  { name: 'Federated States of Micronesia', symbol: 'FM' },
  { name: 'Fiji', symbol: 'FJ' },
  { name: 'Finland', symbol: 'FI' },
  { name: 'French Guiana', symbol: 'GF' },
  { name: 'French Polynesia', symbol: 'PF' },
  { name: 'Gabon', symbol: 'GA' },
  { name: 'Gambia', symbol: 'GM' },
  { name: 'Georgia', symbol: 'GE' },
  { name: 'Ghana', symbol: 'GH' },
  { name: 'Gibraltar', symbol: 'GI' },
  { name: 'Greece', symbol: 'GR' },
  { name: 'Greenland', symbol: 'GL' },
  { name: 'Grenada', symbol: 'GD' },
  { name: 'Guadeloupe', symbol: 'GP' },
  { name: 'Guam', symbol: 'GU' },
  { name: 'Guatemala', symbol: 'GT' },
  { name: 'Guernsey', symbol: 'GG' },
  { name: 'Guinea', symbol: 'GN' },
  { name: 'Guinea-Bissau', symbol: 'GW' },
  { name: 'Guyana', symbol: 'GY' },
  { name: 'Haiti', symbol: 'HT' },
  { name: 'Holy See', symbol: 'VA' },
  { name: 'Honduras', symbol: 'HN' },
  { name: 'Hong Kong', symbol: 'HK' },
  { name: 'Hungary', symbol: 'HU' },
  { name: 'Iceland', symbol: 'IS' },
  { name: 'India', symbol: 'IN' },
  { name: 'Indonesia', symbol: 'ID' },
  { name: 'Iran', symbol: 'IR' },
  { name: 'Iraq', symbol: 'IQ' },
  { name: 'Ireland', symbol: 'IE' },
  { name: 'Isle of Man', symbol: 'IM' },
  { name: 'Israel', symbol: 'IL' },
  { name: 'Italy', symbol: 'IT' },
  { name: 'Ivory Coast', symbol: 'CI' },
  { name: 'Jamaica', symbol: 'JM' },
  { name: 'Japan', symbol: 'JP' },
  { name: 'Jersey', symbol: 'JE' },
  { name: 'Jordan', symbol: 'JO' },
  { name: 'Kazakhstan', symbol: 'KZ' },
  { name: 'Kenya', symbol: 'KE' },
  { name: 'Kiribati', symbol: 'KI' },
  { name: 'Kosovo', symbol: 'XK' },
  { name: 'Kuwait', symbol: 'KW' },
  { name: 'Kyrgyzstan', symbol: 'KG' },
  { name: 'Laos', symbol: 'LA' },
  { name: 'Latvia', symbol: 'LV' },
  { name: 'Lebanon', symbol: 'LB' },
  { name: 'Lesotho', symbol: 'LS' },
  { name: 'Liberia', symbol: 'LR' },
  { name: 'Libya', symbol: 'LY' },
  { name: 'Liechtenstein', symbol: 'LI' },
  { name: 'Luxembourg', symbol: 'LU' },
  { name: 'Macao', symbol: 'MO' },
  { name: 'Madagascar', symbol: 'MG' },
  { name: 'Malawi', symbol: 'MW' },
  { name: 'Malaysia', symbol: 'MY' },
  { name: 'Maldives', symbol: 'MV' },
  { name: 'Mali', symbol: 'ML' },
  { name: 'Malta', symbol: 'MT' },
  { name: 'Marshall Islands', symbol: 'MH' },
  { name: 'Martinique', symbol: 'MQ' },
  { name: 'Mauritania', symbol: 'MR' },
  { name: 'Mauritius', symbol: 'MU' },
  { name: 'Mayotte', symbol: 'YT' },
  { name: 'Mexico', symbol: 'MX' },
  { name: 'Monaco', symbol: 'MC' },
  { name: 'Mongolia', symbol: 'MN' },
  { name: 'Montenegro', symbol: 'ME' },
  { name: 'Montserrat', symbol: 'MS' },
  { name: 'Morocco', symbol: 'MA' },
  { name: 'Mozambique', symbol: 'MZ' },
  { name: 'Myanmar', symbol: 'MM' },
  { name: 'Namibia', symbol: 'NA' },
  { name: 'Nauru', symbol: 'NR' },
  { name: 'Nepal', symbol: 'NP' },
  { name: 'Netherlands', symbol: 'NL' },
  { name: 'New Caledonia', symbol: 'NC' },
  { name: 'New Zealand', symbol: 'NZ' },
  { name: 'Nicaragua', symbol: 'NI' },
  { name: 'Niger', symbol: 'NE' },
  { name: 'Nigeria', symbol: 'NG' },
  { name: 'Niue', symbol: 'NU' },
  { name: 'Norfolk Island', symbol: 'NF' },
  { name: 'North Korea', symbol: 'KP' },
  { name: 'North Macedonia', symbol: 'MK' },
  { name: 'Northern Mariana Islands', symbol: 'MP' },
  { name: 'Norway', symbol: 'NO' },
  { name: 'Oman', symbol: 'OM' },
  { name: 'Pakistan', symbol: 'PK' },
  { name: 'Palau', symbol: 'PW' },
  { name: 'Palestine', symbol: 'PS' },
  { name: 'Panama', symbol: 'PA' },
  { name: 'Papua New Guinea', symbol: 'PG' },
  { name: 'Paraguay', symbol: 'PY' },
  { name: 'Peru', symbol: 'PE' },
  { name: 'Philippines', symbol: 'PH' },
  { name: 'Pitcairn Islands', symbol: 'PN' },
  { name: 'Poland', symbol: 'PL' },
  { name: 'Portugal', symbol: 'PT' },
  { name: 'Puerto Rico', symbol: 'PR' },
  { name: 'Qatar', symbol: 'QA' },
  { name: 'Republic of Lithuania', symbol: 'LT' },
  { name: 'Republic of Moldova', symbol: 'MD' },
  { name: 'Romania', symbol: 'RO' },
  { name: 'Russia', symbol: 'RU' },
  { name: 'Rwanda', symbol: 'RW' },
  { name: 'Réunion', symbol: 'RE' },
  { name: 'Saint Barthélemy', symbol: 'BL' },
  { name: 'Saint Helena', symbol: 'SH' },
  { name: 'Saint Lucia', symbol: 'LC' },
  { name: 'Saint Martin', symbol: 'MF' },
  { name: 'Saint Pierre and Miquelon', symbol: 'PM' },
  { name: 'Samoa', symbol: 'WS' },
  { name: 'San Marino', symbol: 'SM' },
  { name: 'Saudi Arabia', symbol: 'SA' },
  { name: 'Senegal', symbol: 'SN' },
  { name: 'Serbia', symbol: 'RS' },
  { name: 'Seychelles', symbol: 'SC' },
  { name: 'Sierra Leone', symbol: 'SL' },
  { name: 'Singapore', symbol: 'SG' },
  { name: 'Sint Maarten', symbol: 'SX' },
  { name: 'Slovakia', symbol: 'SK' },
  { name: 'Slovenia', symbol: 'SI' },
  { name: 'Solomon Islands', symbol: 'SB' },
  { name: 'Somalia', symbol: 'SO' },
  { name: 'South Africa', symbol: 'ZA' },
  { name: 'South Georgia and the South Sandwich Islands', symbol: 'GS' },
  { name: 'South Korea', symbol: 'KR' },
  { name: 'South Sudan', symbol: 'SS' },
  { name: 'Spain', symbol: 'ES' },
  { name: 'Sri Lanka', symbol: 'LK' },
  { name: 'St Kitts and Nevis', symbol: 'KN' },
  { name: 'St. Vincent and the Grenadines', symbol: 'VC' },
  { name: 'Sudan', symbol: 'SD' },
  { name: 'Suriname', symbol: 'SR' },
  { name: 'Svalbard and Jan Mayen', symbol: 'SJ' },
  { name: 'Sweden', symbol: 'SE' },
  { name: 'Switzerland', symbol: 'CH' },
  { name: 'Syria', symbol: 'SY' },
  { name: 'Taiwan', symbol: 'TW' },
  { name: 'Tajikistan', symbol: 'TJ' },
  { name: 'Tanzania', symbol: 'TZ' },
  { name: 'Thailand', symbol: 'TH' },
  { name: 'Togo', symbol: 'TG' },
  { name: 'Tokelau', symbol: 'TK' },
  { name: 'Tonga', symbol: 'TO' },
  { name: 'Trinidad and Tobago', symbol: 'TT' },
  { name: 'Tunisia', symbol: 'TN' },
  { name: 'Turkey', symbol: 'TR' },
  { name: 'Turkmenistan', symbol: 'TM' },
  { name: 'Turks and Caicos Islands', symbol: 'TC' },
  { name: 'Tuvalu', symbol: 'TV' },
  { name: 'U.S. Minor Outlying Islands', symbol: 'UM' },
  { name: 'U.S. Virgin Islands', symbol: 'VI' },
  { name: 'Uganda', symbol: 'UG' },
  { name: 'Ukraine', symbol: 'UA' },
  { name: 'United Arab Emirates', symbol: 'AE' },
  { name: 'Uruguay', symbol: 'UY' },
  { name: 'Uzbekistan', symbol: 'UZ' },
  { name: 'Vanuatu', symbol: 'VU' },
  { name: 'Venezuela', symbol: 'VE' },
  { name: 'Wallis and Futuna', symbol: 'WF' },
  { name: 'Western Sahara', symbol: 'EH' },
  { name: 'Yemen', symbol: 'YE' },
  { name: 'Zambia', symbol: 'ZM' },
  { name: 'Zimbabwe', symbol: 'ZW' },
]
